import { IChangeContractChargeDateDTO } from 'modules/customer/domain/dtos';
import { IContractChargeDatesRepository } from 'modules/customer/domain/repositories';

export class ChangeContractChargeDateUseCase {
  constructor(
    private contractChargeDatesRepository: IContractChargeDatesRepository,
  ) {}

  public async execute({ contractId, date }: IChangeContractChargeDateDTO) {
    return this.contractChargeDatesRepository.update({
      contractId,
      date,
    });
  }
}
